export const updateData = async (token, url, body) => {
    try {
        const response = await fetch(url, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': token },
            body: JSON.stringify(body),
        })

        return await response.json();
    } catch (err) {
        console.error('Error updating data:', err);
        console.log(err);
    }   
}